module.exports = {
    all:{
        'application': 'Activity application',
        'Pleaseenjoy': 'Please fill in the amount you can enjoy according to the event conditions',
        'Fillamount': 'Fill in the application amount (optional)',
        'Applynow': 'Apply now',

        'howtoplay': 'howtoplay',
        'playContent': 'Content',
    },
    header: {
        'home': 'home',
        'boardgame': 'board ',
        'electronicgames': 'electronic ',
        'livevideo': 'live ',
        'eSportsbattle': 'eSports ',
        'lotterybetting': 'Lottery ',
        'sportingevents': 'Sporting ',
        'Promotions': 'Promotions',
        'Entitybrand': 'Entity brand',
        'onlinebrand': 'online brand',
        'specialized': 'specialized',
        'Proxylogin': 'Proxy login',
        'Regularlicense': 'Regular license',
        'borrow': 'borrow',
        'YueBao': 'Yuebao',
        'Login': 'Login',
        'register': 'Register',
        'Signout': 'Sign out',
        'nohaveTost': 'Coming soon, stay tuned!',
        'Notmember': 'Not a member yet?',
        'review': 'Check the review status',
        'Alloffers': 'All offers',
    },
    foot: {
        'contactus': 'contact us',
        'Strive': 'Strive to provide you with quality service',
        'Agent': 'Agent to join',
        'Let': 'Let us join hands to create a better future',
        'Join': 'Join Consulting',
        'security': 'security',
        'Professional': 'Professional gaming operation platform',
        'Gaming': 'Gaming license',
        'Hold': 'Hold a Pagcor legal license',
        'View': 'View now',
        'about': 'about us',
        'contact': 'contact details',
        'Agents': 'Agent to join',
        'Disclaimer': 'Disclaimer',
        'Privacy': 'Privacy Policy',
        'common': 'common problem',
        'game': 'Gaming Responsibility',
        'All': 'All rights Reserved',
        'kefgu': ' 24 hours online customer service',
        'actual': ' actual name',
        'real': ' please enter your real name',
        'number': ' contact number',
        'enterqq': ' Please enter your contact number',
        'Reason': ' Reason for Application',
        'enter': ' Please enter your reason for application',
        'Applications': ' Applications for Membership',
        'correct': ' Apply to enter the correct mobile phone number',
        'enters': ' Please enter the reason for application',
    },
    app: {
        'loading': 'loading..',
        'sure': 'Are you sure you want to log out',
        'hint': 'hint',
        'Yes': 'Yes',
        'No': 'No',
        'Linking': 'Linking to human support!',
        'Already': 'Already on the current page!',
        'Red': 'Red envelopes are closed!',


        'delete': 'Please delete the old version of the APP and reinstall it',
        'iOS': 'iOS users please use Safari browser to open page download',
        'Scan': 'Scan code to download APP',
        'Direct': 'Direct access without downloading',
        'Installation': 'Installation Tutorial',
        'Download': 'Download, install and register in the same network environment, do not switch networks,',
        'cannot': 'If it cannot be downloaded normally, please use the mobile browser to open it. ',
        'ios1': '1. After scanning the code, click [Download Now] on the page',
        'ios2': '2. Click [Allow]',
        'ios3': '3. Click [Close] to enter the settings',
        'ios4': '4. Click the description file to install',
        'ios5': '5. Click [Install]',
        'ios6': '6. [Allow] Website configuration description file',
        'ios7': '7. Click [Install] to successfully install and play to your heart’s content',
        'adr1': '1. After scanning the code, click [Download Now] on the page',
        'adr2': '2[Allow] browser to access your device',
        'adr3': '3. Click [Download]',
        'adr4': '4. Select the file when the download is complete',
        'adr5': '5. Click [Settings]',
        'adr6': '6. Allow your device to install apps',
    },
    main: {
        'amount': 'Please enter the operation amount!',
        'wallet': 'Platform wallet',
        'operation': 'Successful operation!',
        'withdrawal': 'A single withdrawal cannot be less than 100 !',
        'select': 'Please select the bank card you want to withdraw to!',
        'enter': 'Please enter your payment password!',
        'successfully': 'Submitted successfully, waiting for background review!',
        'address': 'Please select USDT address!',
        'name': 'Please enter depositor name!',
        'type': 'Please enter bank type!',
        'number': 'Please enter your bank card number!',
        'account': 'Please enter the bank account address!',
        'correct': 'Please enter the correct amount!',
        'Jumping': 'Jumping...',
        'going': 'going to page',
        'open': 'Going to open game page!',
        'Copy': 'Copy successfully!',
        'correctamount': 'Please enter the correct amount!',
    },
    register: {
        'registerWelcome': 'Welcome!',
        'joinin': 'join in',
        'Entertainment': 'Entertainment platform, with unique member account value:',
        'maximum1': '1. The first deposit can enjoy up to 9999 yuan in cash back, and you can enjoy it after registration!',
        'maximum2': '2. The maximum rebate from 1 yuan is 3.0% from time to time, and more chess and card electronic discounts are waiting for you!',
        'maximum3': '3, maximum game to enjoy every day: [recharge every day to send, monthly cash back',
        'maximum4': 'Enjoy the most luxurious video game package in the industry!',
        'maximum5': 'For details, please click [Latest Offers] in the upper right corner to view! !',
        'Signup': 'Sign up ',
        'account': 'Login account:',
        'number': 'Account number (minimum 6 characters, in English and numbers)',
        'password': 'login password:',
        'minimumPassword': 'Password (minimum 8 characters, English and numeric)',
        'Confirm': 'Confirm Password:',
        'confirmconfirm': 'Please confirm your confirm',
        'Member': 'Member Profile',
        'actual': 'actual name:',
        'real': 'please enter your real name',
        'Withdrawals': 'Withdrawals password:',
        'withdrawal': 'Please enter the 6-digit withdrawal password',
        'code': 'code :',
        'verification': 'Please enter your verification code',
        'confirmthat': 'read and accepted ',
        'Agreement': ' Terms and Privacy Agreement',
        'submit': 'submit',
        'havean': 'have an account , ',
        'hint': 'hint:',
        'bring': 'bring',
        'required': 'items are required.',
        'proof': 'The withdrawal password is the proof of the withdrawal amount, please remember to fill in the password . ',
        'other': 'Reminder: If you encounter other problems such as the same name or unable to register during the registration process, please contact the online customer service, we will solve it for you as soon as possible!',
        'read': 'Please read and agree to the relevant terms and privacy agreement!',
        'Username': 'Username must be no less than 6 characters long, with a combination of letters and numbers!',
        'Password': 'Password length at least 8 characters! Combine letters and numbers!',
        'match': 'The two passwords do not match!',
        'formatname': 'The name format is incorrect, it can be Chinese or English name!',
        'length': 'The length of the payment password must be 6 digits! !',
        'codeerror': 'Verification code error!',
    },
    login: {
        'tologin': 'Member login, welcome to login!',
        'usernameas': 'username:',
        'usernameA': 'Please enter your username',
        'passwordS': 'password:',
        'pleasepassword': 'please enter your password!',
        'verification': 'verification code',
        'verificationCS': 'please enter verification code!',
        'Noaccount': 'No account,',
        'Verificationerror': 'Verification code error!',
        'blacklist': 'You have been set as a blacklist and cannot log in temporarily, please contact the administrator! ',
         'stop': 'The user has been disabled, please contact the administrator! ',
    }
    ,
    index: {
        'Welcome': 'Welcome to',
        'Latest': 'Latest Announcement',
        'VIP': 'VIP exclusive',
        'Quick': 'Quick recharge',
        'Discount': 'Discount Hall',
        'Deposit': '1.2% Deposit Discount, 3.0% Maximum Cash Back',
        'Comprehensive': 'Comprehensive game area',
        'beauty': 'beauty anchor',
        'Games': 'Games and Entertainment',
        'Exclusive': 'Exclusive Dealer Collection',
        'Experience': 'Experience European beauty',
        'players': '20,000 online players',
        'baccarat': 'The only baccarat',
        'have': 'have fun',
        'beautiful': 'beautiful anchor',
        'play': 'play new OG',
        'most': 'most popular',
        'Classic': 'Classic gameplay',
        'Preferred': 'Preferred by local tyrants',
        'extreme': 'extreme pictures',
        'surprise': 'surprise',
        'Gamess': 'Game experience',
        'visual': '3D visual feast',
        'levels': 'more levels',
        'rich': 'rich gameplay',
        'high': 'high frequency lottery',
        'Diversified': 'Diversified gameplay',
        'richest': 'Asia’s richest event',
        'fast': 'fast settlement',
        'top': 'The world’s top entertainment platforms are readily available',
        'complete': 'The most complete chess and card game on the entire network, with a cumulative prize pool of 100 million yuan, and the grand prize is imminent!',
        'Kaiyuan': 'Kaiyuan ',
        'New': 'New World ',
        'FG': 'FG ',
        'VG': 'VG ',
        'More': 'More',
        'chess': 'The most complete chess and card game on the entire network, with a cumulative prize pool of 100 million yuan, and the grand prize is imminent!',
        'Dynasty': 'Dynasty ',
        'HB': 'HB ',
        'PG': 'PG ',
        'PP': 'PP ',
        'Indiana': 'Indiana Jones',
        'Quality': 'Quality service ultimate experience',
        'Authorized': 'Authorized by the Government of the Macao Special Administrative Region',
        'Government': 'Authorized by the Government of the Kingdom of Europe',
        'Isle': 'Authorised by the Isle of Man Government',
        'Republic': 'Authorized by the Government of the Republic of the Philippines in Asia',
        'announcement': 'Notice',
        'official': '★★★The official platform operator service provider regularly, please check the latest account of the TG account and the account of our company! Not responsible for paying bills! Please give your per entry fee! Please check the latest bank deposit.',
        'playgames': 'play',
        'allgames': 'all games',
        'obz': 'OB ',
        'fgz': 'FG ',
        'ppz': 'PP ',
        'aez': 'AE ',
        'pgz': 'PG ',
         'fgfish': 'FG fishing',
        'TFdz': 'TF E-sports official website is a professional e-sports quiz platform provider in China, providing services such as King Glory quiz, League of Legends quiz, DOTA2 quiz, CSGO quiz live broadcast, popular e-sports videos and the latest e-sports information.',
        'fydz': 'Fanya E-Sports is a product of the Philippine Industry Group, a global quiz system supplier, providing e-sports services such as League of Legends, DOTA2, and CSGO.',
        'obdz': 'OB e-sports, tens of thousands of e-sports options; industry-leading settlement speed of competition results.',
        'aidz': 'Provide 20 e-sports events every month, in 2000, tens of thousands of e-sports options; has the industry-leading settlement speed of competition results.',
        'activity': 'activity details',
        'Event': 'Event Terms and Conditions',
        'How': 'How to apply',
        'Eligible': 'Eligible members please apply in the same month, overdue will be regarded as giving up!',
        'Please': 'Please fill in your application information below',
        'member': 'member account',
        'fill': 'Please fill in your member account correctly',
        'will': 'It will be processed for you within 30 minutes after submitting, check',
        'Audit': '【Audit progress】',
        'thanks': ',thanks!',
        'application': 'submit application',
    },
    mine: {

        'welcome2': ', welcome',
        'Financial': 'Financial Center',
        'Loan': 'My Loan',
        'interest': 'My interest',
        'Center': 'Member Center',
        'soon': 'Coming soon, stay tuned！！',
        'qihao': 'issue number',
        'Quota': 'Quota Conversion',
        'transfermode': 'transfer mode',
        'Spin': 'Free Spin Mode',
        'refresh': 'refresh',
        'recycling': 'click recycling',
        'Click': 'Click [Refresh] to update balance data',
        'Account': 'Account Balance',
        'balance': 'game balance',
        'transfer': 'transfer method',
        'transferin': 'transfer in',
        'transferout': 'transfer out',
        'Action': 'Action amount',
        'Fill': 'Fill in the amount',
        'confirm': 'confirm',
        'Platform': 'Platform wallet',
        'operation': 'Please enter the operation amount!',
        'Successful': 'Successful operation!',

        'osit': 'Deposit',
        'Select': 'Select payment method',
        'Bank': 'Bank Card',
        'USDT': 'USDT',
        'Alipay': 'Alipay',
        'WeChat': 'WeChat',
        'Manual': 'Manual recharge',
        'Submission': 'Deposit Submission',
        'Payment': 'Payment method:',
        'information': 'Receiving bank information',
        'Payments': 'Payment account:',
        'Copy': 'Copy',
        'AccountName': 'Account Name:',
        'Bankdeposit': 'Bank of deposit:',
        'BankAddress': 'Bank Address:',
        'PaymentInformation': 'Payment Information',
        'AccountNamea': 'Account Name:',
        'SelectBank': 'Select Bank Type',
        'selectsupporting': 'Please select a supporting bank',
        'PayerName': 'Payer Name',
        'fillname': 'Please fill in the name of the payer',
        'Banknumber': 'Bank card number',
        'fillcard': 'Please fill in the payer’s bank card number',
        'opening': 'Account opening bank address',
        'address': 'Please fill in the address of the account opening bank',
        'Recharge': 'Recharge amount',
        'enterwithdrawal': 'Please enter the withdrawal amount',
        'Submit': 'Submit',
        'measures': 'Preventive measures',
        'Before': '1. Before each deposit, please go to this page to check the latest receiving account. ',
        'funds': 'Do not deposit funds into the old account yourself. ',
        'into': 'If it is deposited into the old account, the company will not be able to check and will not be responsible. ',
        'Please2': '2. Please try to deposit in the same bank. ',

        'areanother': 'If you are in another bank, please arrive as soon as possible to facilitate the system to speed up your deposit. ',
        'wallet': 'Select wallet type',
        'supported': 'Please select a supported wallet type',


        'arrival': 'Actual arrival',
        'exchange': 'Reference exchange rate:',
        'Human': 'Human service',
        'Contact': 'Contact human customer service',


        'reminder': 'Warm reminder',
        'also': 'You are also binding a wallet card, please go to add! ',
        'binding': 'Go to binding',
        'enterdepositor': 'Please enter the name of the depositor',
        'enterbank': 'Please enter the bank type',
        'enterbanks': 'Please enter the bank bank number',
        'enteraccount': 'Please enter the bank account address',
        'enteramount': 'Please enter the amount in',
        'SuccBetweenessful': 'Between! ',
        'Submitted': 'Submitted successfully, waiting for background review',
        'Jumping': 'Jumping...',
        'Copysuccessfully': 'Copy successfully! ',

        // 取款
        'Withdrawal1': 'Withdrawal',
        'Addaccount1': 'Add account',
        'bankpayment1': 'Go to the bound bank card to receive payment',
        'USDTpayment1': 'Go to the bound USDT address to receive payment',
        'Receiving1': 'Receiving account',
        'Receiving12': 'Please select Receiving account',
        'Accountbalance1': 'Account balance',
        'Codesize1': 'Code size',
        'Withdrawalamount1': 'Withdrawal amount',
        'enterwithdrawal1': 'Please enter the withdrawal amount',
        'password1': 'Withdrawal password',
        'enterpassword1': 'Please enter the withdrawal password',
        'transaction1': 'Per transaction fee',
        'USDTconversion1': 'USDT conversion',
        'questions1': 'If you have any questions, please contact',
        'Online1': 'Online Services',
        'Apply1': 'Apply for withdrawal',
        'measures1': 'Precautionary measures',
        'platforms1': 'Reminder: game platforms with balances may not be able to return all balances to the main wallet due to platform policy factors. ',
        'limit1': 'Today’s withdrawal limit: the remaining 99999999.00 yuan/total 99999999.00 yuan The number of withdrawals today: the remaining 999999/total 999999 withdrawal amount must be greater than the withdrawal fee to withdraw. ',
        'supporting1': 'Please select a supporting bank',
        'opening1': 'Fill in the opening bank',
        'enteropening1': 'Please enter the account opening bank',
        'cardnumber1': 'Fill in the card number',
        'cardholder1': 'Fill in the cardholder’s name',
        'Paymentpassword1': 'Payment password',
        'Binding1': 'Binding',
        'wallet1': 'Please select a wallet protocol',
        'USDTaddress1': 'Fill in USDT address',
        'enterUSDTaddress1': 'Please enter USDT address',
        'osenterpaymentpasswordit1': 'Please enter the payment password',
        'entername1': 'Please enter your name',
        'enterthebank1': 'Please enter the bank',
        'enteraddress1': 'Please enter the address of the account opening bank',
        'enterbanknumber1': 'Please enter the bank card number',
        'enterpaymentpassword1': 'Please enter the payment password',
        'correctlength1': 'Please enter the correct length of the card number',
        'enterofpassword1': 'Please enter the length of the password',
        'Bindingsuccessful1': 'Binding successful',
        'singlecannot1': 'A single withdrawal cannot be less than 100 yuan',
        'bankwithdrawto1': 'Please select the bank card you want to withdraw to',
        'paymentpassword1': 'Please enter your payment password',
        'successfullywaiting1': 'Submitted successfully, waiting for background review',
        'selectUSDTaddress1': 'Please select USDT address',

        // 银行卡 钱包管理
        'management': 'Card package management',
        'Managementaa': 'Management',
        'Clickbank': 'Click to add bank card',
        'ClickUSDT': 'Click to add USDT address',
        'Unbinding': 'Unbinding',
        'BankName': 'Bank Name',
        'BankHead': 'Bank Head',
        'Accountaddress': 'Account opening address',
        'Wallettype': 'Wallet type',
        'Walletaddress': 'Wallet address',
        'Walletprotocol': 'Wallet protocol',
        'Reminder': 'Reminder: Each account can only be bound with 5 bank cards/USDT wallets. If you modify it, please delete it and add it again! ',
        'Arewant': 'Are you sure you want to unbind? ',
        'Unbindingsucceeded': 'Unbinding succeeded',

        'Transactionhistory': 'Transaction history',
        'BetHistory': 'Bet History',
        'Rebaterecord': 'Rebate record',
        'applicationrecord': 'Activity application record',
        'Proxyapplication': 'Proxy application',
        'Redenvelope': 'Red envelope',
        'Personalinformation': 'Personal information',
        'MessageCenter': 'Message Center',


        'Internalmessage': 'Internal message',
        'Announcement': 'Announcement',



        'Improving2': 'Improving personal information can improve account security. After the real name is set, you can only contact customer service to modify it. Please fill in carefully! ',
        'Contact2': 'Contact Customer Service',
        'Username2': 'Username',
        'realname2': 'real name',
        'Birthdate2': 'Birthdate',
        'Mailbox2': 'Mailbox',
        'Mobilenumber2': 'Mobile number',
        'Confirmation2': 'Confirmation',
        'SecurityCenter2': 'Security Center',
        'Modifylogin2': 'Modify login password',
        'loginbeen2': 'The login password has been set, and the login password can be modified by setting it again',
        'Modify2': 'Modify',
        'Changesecurity2': 'Change security password',
        'securitybeen2': 'The security password has been set, and the security password can be modified by setting it again',
        'alreadyapplied2': 'If you have already applied, please do not apply again',
        'enteroriginal2': 'Please enter the original password',
        'enternew2': 'Please enter a new password',
        'newenter2': 'Please re-enter the new password',
        'yourname2': 'your name',
        'enterreason2': 'Please enter the reason for application',
        'enterphone2': 'Please enter the correct phone number',
        'enterapplication2': 'Please enter the reason for application',
        'enterold2': 'Please enter the old password',
        'enternewpassword2': 'Please enter a new password',
        'enterpasswordlength2': 'Please enter the correct old password length',
        'entercorrect2': 'Please enter the correct new password length',
        'enterconfirmation2': 'Please enter the confirmation password',
        'passwordstwo2': 'The two passwords do not match! ',
        'oldnew2': 'The old and new passwords cannot be the same! ',
        'changed2': 'Password changed successfully! ',
        'enterphoneenter2': 'Please enter the correct phone number',
        'enteremail2': 'Please enter the correct email number',
        'entercorrect2w': 'Please enter the correct date format: YYYY-MM-DD',


        'platform': 'Select platform',
         'Transactiontype': 'Transaction type',
         'Selectplatform': 'Select platform',
         'Timerange': 'Time range',
         'today': 'today',
         'week': 'within a week',
         'month': 'within half a month',
         'onemonth': 'within one month',
         'number': 'serial number',
         'time': 'time',
         'Ordernumber': 'Order number',
         'Transactiontypea': 'Transaction type',
         'Amount': 'Amount',
         'Status': 'Status',
         'Nodata': 'No data',
         'undefined': 'undefined',
         'reviewed': 'to be reviewed',
         'Approved': 'Approved',
         'Audit': 'Audit Denied',
         'Failed': 'Failed',
         'success': 'success',
         'settled': 'To be settled',
         'platforms': 'All platforms',

         'Gamename': 'Game name',
         'Payout': 'Payout',

         'Invalidbet': 'Invalid bet',
         'Payouts': 'Payout',
         'Unpaid': 'Unpaid',

         'Rebatestatus': 'Rebate status',
         'Accumulatedpayment': 'Accumulated payment',
         'Unpaidsdf': 'Unpaid',
         'Received': 'Received',
         'Not': 'Not yet paid',
         'Receive': 'Receive',
         'Rebateamount': 'Rebate amount',
         'Rebatetime': 'Rebate time',
         'Collectiontime': 'Collection time',
         'Thereclaim': 'There is no claim limit yet! ',
         'ApplicationTime': 'Application Time',
         'Applycontent': 'Apply for preferential content',
         'Auditresult': 'Audit result',


         'Redsituation': 'Red envelope situation',
         'Accumulated': 'Accumulated number of receipts',
         'Remaining': 'Remaining number of claims',
         'Receives': 'Receive a red envelope',
         'Redenvelopes': 'Red envelope amount',
         'Rechargetimes': 'Recharge time',
         'havetrialss': 'You don’t have enough trials left! ',
         'Servererrors': 'Server error, please try again later!',

         'paymentss': 'Remaining payment time',
         'Orderv': 'Order number',
         'Currentv': 'Current exchange rate',
         'Rechargev': 'Recharge amount',
         'Pleasev': 'Please note: your actual credited amount should be exactly the same as this amount, otherwise it will not be credited in time',
         'Pleaseva': '1. Please do not deposit any non-payment to the above address',
         'Assetva': 'Asset, otherwise the asset will be lost;',
         'Pleasevaa': '2. Please make sure that your computer and browser are secure to prevent information from being tampered with or leaked. ',
         'Afterv': '2. After recharging to the above address, it needs to be confirmed by the network node block, and the account will be received after confirmation by the network on the chain;',
         'Pleasevas': '3. Please make sure your computer and browser are secure to prevent information from being tampered with or leaked. ',
         'Protocolv': 'Protocol: Please use',
         'TRON': 'TRON Chain',
         'Ethereum': 'Ethereum chain',
         'Protocol': 'Protocol',
         'For': 'For the transaction, the recharge caused by other smart chains will not be accounted for, and the amount loss will be borne by yourself. ',
         'Paymentvas': 'Payment completed',
    }
    , vip: {
        'level': 'VIP level',
        'conditions': 'Promotion conditions',
        'water': 'Reverse water ratio',
        'running': 'Accumulated running water',
        'recharge': 'Cumulative recharge',

        'CASINO': 'CASINO',
        'SLOTS': 'SLOTS',
        'CARD': 'CARD',
        'SPORTS': 'SPORTS',
        'LOTTERY': 'LOTTERY',
        'ESPORT': 'ESPORT',
    },
    Redenvelope:{
        'Remaining': 'Remaining number of claims',
        'Received': 'Received',
        'bout': 'bout',
        'Currently': 'Currently available at most',
        'meet': 'Go and meet the conditions! ',
        'activity': 'activity time',
        'amount': 'Cumulative recharge amount',

        'Number': 'Number of red envelopes',
        'Collection': 'Collection rules',
        'After': '1. After grabbing the red envelope, the system will automatically pay out prizes,',
        'Second': 'Second to account',
        'you': ', you can withdraw money after reaching the turnover multiple;',
        'Conditions': '2. Conditions for receiving red envelopes: The recharge amount needs to be within the specified activity date (Eastern time), and according to the accumulated recharge amount, the number of red envelope grabs can be obtained, and the corresponding number of red envelopes can be grabbed;',
        'Note': 'Note:',
        'Grabred': 'Grab a red envelope',
        'Beijing': 'Beijing time is from 10:00 to 12:00 every morning, and the deposit is calculated from 12:00 the previous day to 10:00 today, thank you~',
        'Daily': 'Daily million cash red envelopes! The more deposits you have, the more opportunities you will have. The red envelopes will never stop, and the surprises will never stop. What are you waiting for? Call your friends to share! ! ',
        'Members': '1. Members must be within the specified event date (Eastern Time), according to the accumulated amount of recharge, to obtain the corresponding number of red packets. If the deposit amount is not reached within the specified time frame, the number of red envelope grabs will not be counted, and the overdue will be void! ',
        'All': '2. All activity offers are specially designed for players. If any group or individual is found to be dishonestly extracting bonuses or any threat, abuse of company offers, etc., the company reserves the right to freeze, cancel the group or Rights to personal accounts and account balances. ',
        'rights': 'All rights of interpretation are reserved, and promotions can be changed, stopped or cancelled at any time. ',
        'event': 'The event has not started, please wait for the event to start. ',
        'Please': 'Please wait for the next event. ',
        'Congratulations': 'Congratulations',
        'Grab': 'Grab',
        'meta': 'meta',
        'Recharge': 'Recharge',
        'met': 'You haven’t met the requirements yet, go and finish it! ',
        'Server': 'Server exception, please try again later',

    }
}
// ’


// WEBPACK FOOTER //
// ./src/i18n/en.js